import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { UiIcons, type UiIconName } from '../icons/ui-icons';
import { ButtonDirective, type ButtonVariants } from '../spartan/button.directive';

@Component({
  selector: 'app-action-button',
  standalone: true,
  imports: [ButtonDirective, SafeHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      appButton
      [type]="type()"
      [variant]="variant()"
      [size]="size()"
      [rounded]="rounded()"
      [class]="userClass()"
      [disabled]="disabled() || loading()"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-busy]="loading() || null"
      (click)="action.emit($event)"
    >
      @if (iconHtml(); as svg) {
        @if (iconPosition() === 'start') {
          <span class="contents" [innerHTML]="svg | safeHtml"></span>
        }
      }

      @if (label()) {
        <span>{{ label() }}</span>
      } @else {
        <ng-content />
      }

      @if (iconHtml(); as svg) {
        @if (iconPosition() === 'end') {
          <span class="contents" [innerHTML]="svg | safeHtml"></span>
        }
      }
    </button>
  `,
})
export class ActionButtonComponent {
  readonly label = input('');
  readonly icon = input<UiIconName | string | null>(null);
  readonly iconPosition = input<'start' | 'end'>('start');
  readonly variant = input<ButtonVariants['variant']>('default');
  readonly size = input<ButtonVariants['size']>('default');
  readonly rounded = input<ButtonVariants['rounded']>('default');
  readonly type = input<'button' | 'submit' | 'reset'>('button');
  readonly disabled = input(false);
  /** Deshabilita el botón y reemplaza el ícono por un spinner mientras dura la acción. */
  readonly loading = input(false);
  readonly ariaLabel = input<string | null>(null);
  // eslint-disable-next-line @angular-eslint/no-input-rename -- merged last by ButtonDirective via cn()
  readonly userClass = input('', { alias: 'class' });

  readonly action = output<MouseEvent>();

  protected readonly iconHtml = computed(() => {
    if (this.loading()) return UiIcons.loader;
    const icon = this.icon();
    if (!icon) return null;
    return icon in UiIcons ? UiIcons[icon as UiIconName] : icon;
  });
}
